import { ImageSlider } from '../Slider';
import FibraFotos from './FibraFotos';
import LucchiniComp from './LucchiniCompWeb';
import { useIsMobile } from '../context/MobileContext';
import { lab_list } from '../utils/types';
import VerifiedIcon from '@mui/icons-material/Verified';
import PaidIcon from '@mui/icons-material/Paid';



const BasicInfo:React.FC<{
    width: number,
    activeLabs: Partial<lab_list[0]>[]
}>=({width, activeLabs})=>{

    const isMobile = useIsMobile()

    return(
        <div style={{width:'100%'}}>
            <div style={{fontFamily:'Digital', color:'#ececec', marginTop:'5vh',marginBottom:'5vh', textAlign:'left', lineHeight:isMobile?'14px':'20px', fontSize:isMobile?'10px':'12px'}}>
                O estudio Fibra e um dos mais renomados do mercado, recebendo diariamente artistas consagrados como Ludmilla, Anitta, L7nnon, Martinho da Vila, Tiago Iorc, entre outros.
            </div>
            <ImageSlider width={width}/>
            <div style={{fontFamily:'Digital', color:'#ececec', marginTop:'5vh', textAlign:'left', lineHeight:isMobile?'14px':'20px', fontSize:isMobile?'10px':'12px'}}>
                {/* Guiado por um engenheiro premiado com diversas indicaCOes ao Latin Grammy, vamos abrir sessoes de mixagem de artistas reais para estudar tecnicas de mixagens usadas nos maiores hits do brasil, descobrindo quais plug-ins utilizar, e aprendendo como e quando usar equipamentos analogicos. */}
                Acompanhe de perto o processo de producao, desde a concepcao e criacao de beats, efeitos de voz, camadas e texturas, escolhas de timbres, e todos as ferramentas utilizadas pelos maiores artistas do Brasil, guiado por um produtor musical indicado multiplas vezes ao grammy latino.
            </div>

            {<LucchiniComp mobile={isMobile}/>}

            <div style={{fontFamily:'Digital', color:'#ececec', textAlign:'left', lineHeight:isMobile?'14px':'20px', fontSize:isMobile?'10px':'12px', marginTop:isMobile?'4vh':'8vh'}}>
                O laboratorio oferece a oportunidade de criar networking e trocar conhecimento com a equipe do estudio e outros participantes do workshop. Alem da modalidade presencial, os participantes podem optar pela transmissao online, que sera transmitida atraves do zoom e tera um numero limitado de vagas para maior aproveitamento.
            </div>

            {<FibraFotos id={1} width={width}/>}
            
            <div style={{width:isMobile?'80vw':'500px', margin:isMobile?'290px auto 0px':'440px auto 2vh'}}>
                <div style={{backgroundColor:'#161616', borderRadius:'5px 5px 0 0', fontSize:'10px', fontFamily:'Digital', textAlign:'left', color:"#ececec", padding:'7px'}}>
                    informacoes
                </div>
                <div style={{border:'2px solid #161616', borderRadius:'0 0 5px 5px', fontFamily:'Digital', color:"#fff", fontSize:isMobile?'10px':'12px', textAlign:'left', padding:'7px',lineHeight:'15px'}}>
                    DATA{activeLabs.length>1&&('S')}: {activeLabs.length===1?(<>{activeLabs[0]?.date}<br/></>):activeLabs.map(lab => {return(<div style={{marginLeft:'10px'}}>{lab?.date}</div>)})}
                    HORARIO: 10:00 as 15:00<br/>
                    <div>
                        <div style={{float:'left', marginRight:'5px'}}><VerifiedIcon sx={{fontSize:'12px', color:"#058cdf"}}/></div>
                        <div style={{float:'left', wordWrap:'break-word', width:isMobile?'70vw':''}}>Certificado de Conclusao Digital</div>
                        <div style={{clear:'both'}}/>
                    </div>
                    <div>
                        <div style={{float:'left', marginRight:'5px'}}><PaidIcon sx={{fontSize:'12px', color:"#03ad01"}}/></div>
                        <div style={{float:'left', wordWrap:'break-word', width:isMobile?'70vw':''}}>Descontos em futuros laboratorios</div>
                        <div style={{clear:'both'}}/>
                    </div>
                    LOCAL: ESTUDIO FIBRA OU UM44STUDIOS<br/>
                    RIO DE JANEIRO/RJ
                </div>

            </div>
        </div>
    )
}

export default BasicInfo